import { Grid, styled } from "@mui/material";

export const GridContentDashboard = styled(Grid)(({ theme }) => ({
  backgroundColor: '#F7F8FF',
  height: "calc(100vh - 64px)",
  borderRadius: "40px 0 0 0",
  overflow: "auto"
}))